import styles from './styles.module.css';
import React, {useState, useContext} from 'react';
import CloseIcon from '@mui/icons-material/Close';
import DataTable from 'components/utils/DataTable';
import Info from 'components/utils/Alert/Info';
import DateTimeHelpers from 'helpers/DateTimeHelpers';
import { useTranslation } from 'react-i18next';
import { Button, CircularProgress } from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import AccountServices from '../../services/AccountServices';
import TerminalService from '../../services/TerminalServices';
import { AlertMessagesContext } from 'react-alert-messages';
import { TerminalContext } from '../../Context/TerminalContext';

export default function ShiftPaymentCashBookPopup(props) {
  const { toggleViewCashBook, rowData } = props;
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  const [isConfiguring, setIsConfiguring] = useState(false);
  
  const { postAlertMessage } = useContext(AlertMessagesContext);
  const { terminals, getTerminals: refreshTerminals } = useContext(TerminalContext);
  
  const listHeader = [
    {
      id: 'date',
      label: tCommon('Date'),
      type: 'callback',
      viewRender: (item) => DateTimeHelpers.getDate(item.time || item.date),
    },
    {
      id: 'time',
      label: tCommon('Time'),
      type: 'callback',
      viewRender: (item) => DateTimeHelpers.convertTo12HourTime(item.time || item.date),
    },
    {
      id: 'description',
      label: tCommon('Description'),
      type: 'text',
    },
    {
      id: 'debit',
      label: tCommon('In'),
      type: 'floatAmount',
    },
    {
      id: 'credit',
      label: tCommon('Out'),
      type: 'floatAmount',
    },
    {
      id: 'balance',
      label: tCommon('Balance'),
      type: 'floatAmount',
    },
  ];

  const handleAutoConfigureAccountHead = async () =>{
    setIsConfiguring(true);
    try{
      const paymentModeName = rowData?.summary?.payment_mode?.name;
      const data = {
        name : paymentModeName,
        group_name : 'ASSET',
        type : 'GENERAL',
        balance :0,
        order : null,
        is_enabled : true
      }
      const response = await AccountServices.createAccountHead(data);
      const accountHeadId = response?.id;
      
      if (Array.isArray(terminals) && paymentModeName && accountHeadId) {
        await Promise.all(
          terminals
            .filter((terminal) => terminal.type === 'pos')
            .map(async (terminal) => {
              const config = terminal.config || {};
              const mappings = config.payment_mode_account_head_mappings || {};
              
              mappings[paymentModeName] = accountHeadId;
              config.payment_mode_account_head_mappings = mappings;
              
              return TerminalService.updateTerminals(terminal.id, { config });
            })
        );
        refreshTerminals(); // Refresh context after updating
      }

      postAlertMessage({
        text: tCommon('Account Head created and mapped successfully'),
        type: 'success',
      });
      if (toggleViewCashBook) {
        toggleViewCashBook(null);
      }
    }catch(err){
      postAlertMessage({text: err.message,type: 'failed',});
    }
    setIsConfiguring(false)
  }

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{`${rowData?.summary?.payment_mode?.name} ${tCommon('Book')}`}</h2>
          <CloseIcon
            onClick={() => {
              toggleViewCashBook(null);
            }}
          />
        </div>
        <div className={styles.inputSec}>
          {!rowData?.summary?.isMapped ? (
            <div>
              <Info
                title={tCommon('Ledger Not Configured')}
                content={tCommon('Transactions cannot be displayed because this payment mode is not linked to an account head. Please create an account head and map it in terminal settings.')}
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                <Button 
                  variant="contained" 
                  style={isConfiguring ? {} : { backgroundColor: '#ff851b', color: '#fff' }}
                  onClick={() => handleAutoConfigureAccountHead()}
                  disabled={isConfiguring}
                >
                  {isConfiguring ? (
                    <CircularProgress size={16} color="inherit" sx={{ mr: 0.75 }} />
                  ) : (
                    <AutoFixHighIcon sx={{ mr: 0.75, fontSize: '16px', color: 'inherit' }} />
                  )}
                  {tCommon('Configure Account Head')}
                </Button>
              </div>
            </div>
          ) : rowData.tnx && rowData.tnx.length > 0 ? (
            <DataTable columns={listHeader} rows={rowData.tnx} />
          ) : (
            <Info
              title={tPopup('Cash Book Details not found')}
              content={tPopup('This cash book have no transaction to list up')}
            />
          )}
        </div>
      </div>
    </div>
  );
}
